import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/{-$locale}/_public/rankings')({
  component: RankingsRoute,
})

function RankingsRoute() {
  return <Outlet />
}
